import { Component, Input, OnInit } from '@angular/core';
import { CNPrescriptionEntry } from 'src/app/models/cnprescriptionentry';

@Component({
  selector: 'app-prescription-posology',
  templateUrl: './prescription-posology.component.html',
  styleUrls: ['./prescription-posology.component.scss']
})
export class PrescriptionPosologyComponent implements OnInit {

  @Input() entry: CNPrescriptionEntry;

  constructor() { }

  ngOnInit(): void {
  }

}
